"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _VerifiedUser = _interopRequireDefault(require("@material-ui/icons/VerifiedUser"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _excluded = ["invitedAt", "activatedAt", "activeLabel", "notActiveLabel", "notInvitedLabel", "onStartOnboarding", "onResendOnboarding", "resendOnboardingLabel", "startOnboardingLabel", "loading"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserOnboarding = function UserOnboarding(_ref) {
  var invitedAt = _ref.invitedAt,
      activatedAt = _ref.activatedAt,
      activeLabel = _ref.activeLabel,
      notActiveLabel = _ref.notActiveLabel,
      notInvitedLabel = _ref.notInvitedLabel,
      onStartOnboarding = _ref.onStartOnboarding,
      onResendOnboarding = _ref.onResendOnboarding,
      resendOnboardingLabel = _ref.resendOnboardingLabel,
      startOnboardingLabel = _ref.startOnboardingLabel,
      loading = _ref.loading,
      other = _objectWithoutProperties(_ref, _excluded);

  var invited = !!invitedAt && invitedAt.length > 0;
  var active = !!activatedAt && activatedAt.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ListItem, other, /*#__PURE__*/_react["default"].createElement(_solarReact2.ListItemIcon, null, active ? /*#__PURE__*/_react["default"].createElement(_VerifiedUser["default"], null) : invited ? /*#__PURE__*/_react["default"].createElement(_Error["default"], null) : ''), active ? /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemText, {
    lines: "two",
    primary: activeLabel,
    secondary: activatedAt
  }) : invited ? /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemText, {
    lines: "two",
    primary: notActiveLabel,
    secondary: invitedAt
  }) : /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemText, {
    lines: "single",
    secondary: notInvitedLabel
  }), !active && (invited ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onResendOnboarding();
    },
    disabled: loading,
    variant: "outlined",
    color: "primary"
  }, resendOnboardingLabel) : onStartOnboarding && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onStartOnboarding();
    },
    disabled: loading,
    variant: "outlined",
    color: "primary"
  }, startOnboardingLabel)));
};

UserOnboarding.propTypes = {
  activatedAt: _propTypes["default"].string,
  invitedAt: _propTypes["default"].string,
  activeLabel: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  notActiveLabel: _propTypes["default"].string,
  onStartOnboarding: _propTypes["default"].func,
  onResendOnboarding: _propTypes["default"].func.isRequired,
  resendOnboardingLabel: _propTypes["default"].string,
  startOnboardingLabel: _propTypes["default"].string
};
UserOnboarding.defaultProps = {
  activeLabel: 'Actief als gebruiker',
  notActiveLabel: 'Nog niet geactiveerd',
  notInvitedLabel: 'Nog niet uitgenodigd',
  resendOnboardingLabel: 'Opnieuw versturen',
  startOnboardingLabel: 'Uitnodigen'
};
var _default = UserOnboarding;
exports["default"] = _default;